const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const GTM_ID = process.env.REACT_APP_GTM_ID;
let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;
  if (GTM_ID) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(s);
  }
  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });
  }
}

export function trackPageView(path) {
  initAnalytics();
  if (GA_ID && window.gtag) {
    window.gtag("event", "page_view", { page_path: path, page_title: document.title, page_location: window.location.href });
  }
  if (GTM_ID && window.dataLayer) {
    window.dataLayer.push({ event: "page_view", page_path: path });
  }
}

export function trackEvent(name, params = {}) {
  initAnalytics();
  if (GA_ID && window.gtag) window.gtag("event", name, params);
  if (GTM_ID && window.dataLayer) window.dataLayer.push({ event: name, ...params });
}
